export interface ErrorReportDetails {
  tags?: Record<string, string>;
  contexts?: Record<string, Record<string, unknown>>;
}

export type ReportErrorCallback = (error: Error, details?: ErrorReportDetails) => void;

const defaultImplementation: ReportErrorCallback = (error, details) => {
  console.warn("[errorReporting] reporter not initialized yet", error?.message, details);
};

let reportErrorImplementation: ReportErrorCallback = defaultImplementation;

export const reportError: ReportErrorCallback = (error, details) => {
  reportErrorImplementation(error, details);
};

export const setReportErrorCallback = (callback: ReportErrorCallback) => {
  reportErrorImplementation = callback;
};

export const resetReportErrorCallback = () => {
  reportErrorImplementation = defaultImplementation;
};
